import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/follow-ups/` redirects to the first subnav, Pending Requests, as legacy
 * does; the nav links to the bare path, so without this the tab strip renders
 * over an empty outlet.
 *
 * Done in `beforeLoad`, since no data is needed. Unlike legacy, only the bare
 * slug redirects.
 */
export const Route = createFileRoute('/_app/follow-ups/')({
  beforeLoad: () => {
    throw redirect({ to: '/follow-ups/pending-requests/', replace: true });
  },
});
